import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Flag from '@atlaskit/flag';
import Error from '@atlaskit/icon/glyph/error';
import Info from '@atlaskit/icon/glyph/info';
import Tick from '@atlaskit/icon/glyph/check-circle';
import Warning from '@atlaskit/icon/glyph/warning';
import { colors } from '@atlaskit/theme';

const icon = (key) => {
  const icons = {
    info: <Info label="Info icon" secondaryColor={colors.N500} />,
    success: <Tick label="Success" secondaryColor={colors.G400} />,
    warning: <Warning label="Warning icon" secondaryColor={colors.Y300} />,
    error: <Error label="Error icon" secondaryColor={colors.R300} />,
  };

  return icons[key];
};

const TypeFlag = props => (
  <div style={{ margin: '12px 0 0 0' }}>
    <Flag
      {...props}
      icon={icon(props.appearance)}
      isDismissAllowed
      actions={[
        ...props.actions.map(action => ({
          ...action,
          content: action.text,
        })),
        {
          content: 'Close',
          onClick: props.onClose,
        },
      ]}
    />
  </div>
);

TypeFlag.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object),
  appearance: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
};

TypeFlag.defaultProps = {
  actions: [],
  appearance: 'info',
  children: '',
  title: 'Click to view the message',
};

export default TypeFlag;
